import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';
import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Obstructive Sleep Apnea Treatment | Snoring Surgery in Delhi, India</title>
            <meta name="description" content="Get expert care for Obstructive Sleep Apnea with advanced treatment and snoring surgery in Delhi, India. Restore healthy sleep and breathe better today!" />
            <meta name="keywords" content="Obstructive Sleep Apnea, Obstructive Sleep Apnea Treatment, Obstructive sleep apnea doctor, Obstructive sleep apnea symptoms, Obstructive sleep apnea causes" />
            <link rel="canonical" href="https://entdelhi.com/snoring-sleep-apnea-surgery/" />
            <meta property="og:title" content="Obstructive Sleep Apnea Treatment | Snoring Surgery in Delhi, India" />
            <meta property="og:description" content="Get expert care for Obstructive Sleep Apnea with advanced treatment and snoring surgery in Delhi, India. Restore healthy sleep and breathe better today!" />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
